type HtmlField = {
  target: any;
  propertyKey: any;
  type: any;
};

const htmlFields = new WeakMap<object, HtmlField[]>();
export function htmlType(type: string) {
  return function (
    target: any,
    propertyKey: string
    // descriptor: PropertyDescriptor,
  ) {
    if (!htmlFields.has(target.constructor)) {
      htmlFields.set(target.constructor, []);
    }
    htmlFields.get(target.constructor)!.push({ target, propertyKey, type });
  };
}
export function createHTMLProps(constructor: Function) {
  const myFields = htmlFields.get(constructor) ?? [];
  myFields.forEach((field) => {
    if (field.type === 'date') {
      Object.defineProperty(field.target, 'html_' + field.propertyKey, {
        get: function get_html_date() {
          try {
            const type = typeof this[field.propertyKey];
            const date =
              type === 'string'
                ? new Date(this[field.propertyKey])
                : this[field.propertyKey];
            return date?.toISOString().slice(0, 10);
          } catch (e) {
            return null;
          }
        },
        set: function set_html_date(value: string) {
          try {
            this[field.propertyKey] = new Date(value);
          } catch (e) {
            console.error(e);
          }
        },
      });
    } else if (field.type === 'number') {
      Object.defineProperty(field.target, 'html_' + field.propertyKey, {
        get: function get_html_number() {
          return this[field.propertyKey];
        },
        set: function set_html_number(value: string) {
          const parsed = Number.parseInt(value);
          this[field.propertyKey] = Number.isNaN(parsed) ? value : parsed;
        },
      });
    } else {
      throw new Error('Kenne den Field Type nicht:' + field.type);
    }
  });
}
